var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-resolve-link',{ref:"button",class:[_vm.$options.name, { inverted: _vm.inverted }],attrs:{"slug":_vm.button.reference}},[_c('span',[_vm._v(_vm._s(_vm.button.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }